var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosFooterColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1006 170.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #379b3a;\n      }\n\n      .cls-2 {\n        fill: #379e3a;\n      }\n\n      .cls-3 {\n        fill: #2b491c;\n      }\n\n      .cls-4 {\n        fill: #336327;\n      }\n\n      .cls-5 {\n        fill: #253070;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        fill-rule: evenodd;\n      }\n\n      .cls-13 {\n        fill: #33a83c;\n      }\n\n      .cls-14 {\n        fill: #74c540;\n      }\n\n      .cls-15 {\n        fill: #388433;\n      }\n\n      .cls-16 {\n        fill: #389738;\n      }\n\n      .cls-17 {\n        fill: #33aa3d;\n      }\n\n      .cls-18 {\n        fill: #2f5420;\n      }\n\n      .cls-19 {\n        fill: #389037;\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-21 {\n        fill: #34ab3e;\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-23 {\n        fill: #2fb43e;\n      }\n\n      .cls-6 {\n        fill: #00b949;\n      }\n\n      .cls-24 {\n        fill: #2c481b;\n      }\n\n      .cls-25 {\n        fill: #35a03b;\n      }\n\n      .cls-26 {\n        fill: #388133;\n      }\n\n      .cls-27 {\n        fill: #356c2b;\n      }\n\n      .cls-28 {\n        fill: #2c471b;\n      }\n\n      .cls-29 {\n        fill: #2bb93e;\n      }\n\n      .cls-30 {\n        fill: #36762f;\n      }\n\n      .cls-31, .cls-9 {\n        fill: #f9ec00;\n      }\n\n      .cls-32 {\n        fill: #007637;\n      }\n\n      .cls-33 {\n        fill: #369f3a;\n      }\n\n      .cls-34 {\n        fill: #378b34;\n      }\n\n      .cls-35 {\n        fill: #336628;\n      }\n\n      .cls-36 {\n        fill: #315823;\n      }\n\n      .cls-37 {\n        fill: #398935;\n      }\n\n      .cls-38 {\n        fill: #346729;\n      }\n\n      .cls-39 {\n        fill: #32ab3c;\n      }\n\n      .cls-40 {\n        fill: #2f5422;\n      }\n\n      .cls-41 {\n        fill: #389d39;\n      }\n\n      .cls-42 {\n        fill: #305a23;\n      }\n\n      .cls-43, .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-44 {\n        fill: #369a39;\n      }\n\n      .cls-45 {\n        fill: #398e36;\n      }\n\n      .cls-46 {\n        fill: #378634;\n      }\n\n      .cls-47 {\n        fill: #366d2a;\n      }\n\n      .cls-48 {\n        fill: #388131;\n      }\n\n      .cls-49 {\n        fill: #30b33f;\n      }\n\n      .cls-50 {\n        fill: #315a24;\n      }\n\n      .cls-51 {\n        fill: #305923;\n      }\n\n      .cls-52 {\n        fill: #2e501f;\n      }\n\n      .cls-53 {\n        fill: #377b2f;\n      }\n\n      .cls-54 {\n        fill: #389838;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n        opacity: .8;\n      }\n\n      .cls-8, .cls-10, .cls-11, .cls-12 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-55, .cls-56 {\n        fill: none;\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-58 {\n        fill: #2f5521;\n      }\n\n      .cls-59 {\n        fill: #37a33c;\n      }\n\n      .cls-60 {\n        fill: #315e25;\n      }\n\n      .cls-61 {\n        fill: #379c3a;\n      }\n\n      .cls-62 {\n        fill: #389537;\n      }\n\n      .cls-63 {\n        fill: #2b461a;\n      }\n\n      .cls-64 {\n        fill: #346228;\n      }\n\n      .cls-65 {\n        fill: #325b24;\n      }\n\n      .cls-66 {\n        fill: #f8eb00;\n      }\n\n      .cls-67 {\n        fill: #315d25;\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-69 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-71 {\n        fill: #34a63c;\n      }\n\n      .cls-72 {\n        fill: #367d30;\n      }\n\n      .cls-73 {\n        fill: #399437;\n      }\n\n      .cls-74 {\n        fill: #2e4e1e;\n      }\n\n      .cls-75 {\n        fill: #379137;\n      }\n\n      .cls-76 {\n        isolation: isolate;\n      }\n\n      .cls-77 {\n        fill: #44444b;\n      }\n\n      .cls-78 {\n        fill: #2e5321;\n      }\n\n      .cls-79 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-80 {\n        fill: #30b53e;\n      }\n\n      .cls-81 {\n        fill: #2d4c1d;\n      }\n\n      .cls-82 {\n        fill: #36782f;\n      }\n\n      .cls-83 {\n        fill: #2b4a1c;\n      }\n\n      .cls-84 {\n        fill: #377f31;\n      }\n\n      .cls-85 {\n        fill: #378030;\n      }\n\n      .cls-86 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-87 {\n        fill: #5a5b63;\n        font-family: ArialMT, Arial;\n        font-size: 21.1px;\n      }\n\n      .cls-88 {\n        fill: #368031;\n      }\n\n      .cls-89 {\n        fill: #35692a;\n      }\n\n      .cls-90 {\n        fill: #3b3c43;\n      }\n\n      .cls-91 {\n        fill: #388c35;\n      }\n\n      .cls-92 {\n        fill: #37792e;\n      }\n\n      .cls-93 {\n        fill: #346a2a;\n      }\n\n      .cls-94 {\n        fill: #2f5221;\n      }\n\n      .cls-95 {\n        fill: #ffb000;\n      }\n\n      .cls-56 {\n        clip-rule: evenodd;\n      }\n\n      .cls-96 {\n        fill: #004f85;\n      }\n\n      .cls-97 {\n        fill: #378334;\n      }\n\n      .cls-98 {\n        fill: #32ad3d;\n      }\n\n      .cls-99 {\n        fill: #379338;\n      }\n\n      .cls-100 {\n        fill: #33ac3e;\n      }\n\n      .cls-101 {\n        fill: #399638;\n      }\n\n      .cls-102 {\n        fill: #35722d;\n      }\n\n      .cls-103 {\n        fill: #2e4d1e;\n      }\n\n      .cls-104 {\n        fill: #346829;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10, .cls-11 {\n        opacity: .8;\n      }\n\n      .cls-105 {\n        fill: #346528;\n      }\n\n      .cls-106 {\n        fill: #367a2f;\n      }\n\n      .cls-107 {\n        fill: #326025;\n      }\n\n      .cls-108 {\n        fill: #3a8734;\n      }\n\n      .cls-109 {\n        fill: #388734;\n      }\n\n      .cls-110 {\n        fill: #034ea2;\n      }\n\n      .cls-111 {\n        fill: #3a8d35;\n      }\n\n      .cls-112 {\n        fill: #366e2b;\n      }\n\n      .cls-113 {\n        fill: #346b2b;\n      }\n\n      .cls-114 {\n        fill: #398834;\n      }\n\n      .cls-115 {\n        fill: #29bb3f;\n      }\n\n      .cls-116 {\n        fill: #36702c;\n      }\n\n      .cls-117 {\n        fill: #315722;\n      }\n\n      .cls-118 {\n        fill: #38a23b;\n      }\n\n      .cls-119 {\n        fill: #378332;\n      }\n\n      .cls-120 {\n        fill: #325f26;\n      }\n\n      .cls-121 {\n        fill: #ff0006;\n      }\n\n      .cls-122 {\n        fill: #356f2b;\n      }\n\n      .cls-123 {\n        fill: #27bc40;\n      }\n\n      .cls-124 {\n        fill: #31ae3e;\n      }\n\n      .cls-125 {\n        fill: #2a441a;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-126 {\n        fill: #35a53b;\n      }\n\n      .cls-127 {\n        fill: #388f36;\n      }\n\n      .cls-128 {\n        fill: #36a43c;\n      }\n\n      .cls-129 {\n        fill: #336427;\n      }\n\n      .cls-130 {\n        fill: #377e30;\n      }\n\n      .cls-131 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-132 {\n        fill: #325c25;\n      }\n\n      .cls-133 {\n        fill: #37742e;\n      }\n\n      .cls-134 {\n        fill: #377c2f;\n      }\n\n      .cls-135 {\n        fill: #336127;\n      }\n\n      .cls-136 {\n        fill: #346127;\n      }\n\n      .cls-137 {\n        fill: #2eb73f;\n      }\n\n      .cls-138 {\n        fill: #35732d;\n      }\n\n      .cls-139 {\n        fill: #389237;\n      }\n\n      .cls-140 {\n        fill: #37752e;\n      }\n\n      .cls-141 {\n        fill: #2b471a;\n      }\n\n      .cls-142 {\n        fill: #37a33a;\n      }\n\n      .cls-143 {\n        fill: #388a35;\n      }\n\n      .cls-144 {\n        fill: #31b23e;\n      }\n\n      .cls-145 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-146 {\n        fill: #35702c;\n      }\n\n      .cls-147 {\n        fill: #388233;\n      }\n\n      .cls-148 {\n        fill: #30af3e;\n      }\n\n      .cls-149 {\n        fill: #305623;\n      }\n\n      .cls-150 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-151 {\n        fill: #34a73c;\n      }\n\n      .cls-152 {\n        fill: #305020;\n      }\n\n      .cls-153 {\n        fill: #2d4b1d;\n      }\n\n      .cls-154 {\n        fill: #379939;\n      }\n\n      .cls-155 {\n        fill: #2f5120;\n      }\n\n      .cls-156 {\n        fill: #2b451b;\n      }\n\n      .cls-157 {\n        fill: #36712c;\n      }\n\n      .cls-158 {\n        fill: #2d4f1f;\n      }\n\n      .cls-159 {\n        fill: #305621;\n      }\n\n      .cls-160 {\n        fill: #00031a;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-8);\n        opacity: 0;\n      }\n\n      .cls-161 {\n        fill: #335e26;\n      }\n\n      .cls-162 {\n        fill: #387d30;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M61.5,57.9c-11.9.2-22.2,6.9-27.4,16.8-2.2-5.8-1.8-11.5,6.8-16.8-1.2.7-2.4,1.4-3.6,2.2,5.5-3.8,8.1-4.4,8.1-4.4,8.3-2.9,13.3-2.1,16.1,2.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 637,
    y1: -307.7,
    x2: 637.2,
    y2: -341.7,
    gradientTransform: "translate(-588.6 394.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#006028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#00a43c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37bd64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M94.7,124h0c-10.1,9.5-16.2,3.8-19.5-6.1,10.4-4.8,17.8-15.1,18.3-27.2,2.1,1.3,4.6,2.4,5.9,4.3,5.9,9,2.6,20.3-4.6,29.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1033.7,
    y1: -216.7,
    x2: 1033.9,
    y2: -262.3,
    gradientTransform: "translate(-940.1 349.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M62,52.4c23.9,0,43.3,19.4,43.3,43.3s-4,20.8-10.6,28.4c7.2-8.7,9.8-19.7,3.8-28.7-5.9-9-22.3-8.2-28.2-21.3-5.9-13.1-8.7-23.4-24.9-18.3,5.1-2.1,10.7-3.3,16.6-3.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 44.5,
    y1: 83.3,
    x2: 111.7,
    y2: 83.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#006028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00a43c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3bc069"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M94.6,124.1c-7.9,9.1-19.6,14.9-32.7,14.9-23.9,0-43.3-19.4-43.3-43.3,0,19.8,27.7-1.6,41.5,3.6,14.2,5.3,17.2,41.4,34.5,24.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 18.7,
    y: 94.1,
    width: 76,
    height: 46.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 17.3,
    y1: 120.8,
    x2: 92,
    y2: 120.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#006028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#00a43c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M62,139c-23.9,0-43.3-19.4-43.3-43.3s9-30.4,22.2-37.8c-15.1,11.1-2.4,23.7-.2,36.7,2.7,15.7-12.6,41.4,21.2,44.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1089.3,
    y1: -184.5,
    x2: 1089.8,
    y2: -270.1,
    gradientTransform: "translate(-1051.5 322.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#006028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00a43c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#37bd64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 22,
    y1: 127.5,
    x2: 56.4,
    y2: 108.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f1f9f7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#b1dfd2",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7ac8b3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4db699",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2ba885",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#129e77",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#04986f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00976d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 75.1,
    y1: 122.6,
    x2: 94.7,
    y2: 122.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#aaa8a8",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5d595a",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#302c2c",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 39.5,
    y1: 119,
    x2: 62,
    y2: 119,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 39.5,
    y1: 119.7,
    x2: 62,
    y2: 119.7,
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M158.9,71.6c0,11-9,17.6-18.7,17.6h-8v14.2h-11.8v-49.4h19.8c9.6,0,18.7,6.6,18.7,17.6ZM147.1,71.6c0-4-2.9-6.5-6.8-6.5h-8v12.9h8c3.9,0,6.8-2.4,6.8-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M180.8,89.2h-5.8v14.2h-11.8v-49.4h19.8c9.6,0,18.7,6.6,18.7,17.6s-3.7,12.3-8.9,15.2l9.6,16.6h-13.3l-8.2-14.2ZM175,78.1h8c3.9,0,6.8-2.4,6.8-6.5s-2.9-6.5-6.8-6.5h-8v12.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M225.6,89.2h-5.8v14.2h-11.8v-49.4h19.8c9.6,0,18.7,6.6,18.7,17.6s-3.7,12.3-8.9,15.2l9.6,16.6h-13.3l-8.2-14.2ZM219.7,78.1h8c3.9,0,6.8-2.4,6.8-6.5s-2.9-6.5-6.8-6.5h-8v12.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M127.5,113.3c0,2-1.5,3-3.3,3h-1.7v2.8h-1.6v-8.9h3.2c1.7,0,3.3,1.1,3.3,3ZM125.9,113.3c0-1-.7-1.6-1.7-1.6h-1.7v3.2h1.7c1,0,1.7-.5,1.7-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M130.9,119.2h-1.6v-9.5h1.6v9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M136.4,112.7c1.1,0,2,.6,2.3,1.3v-1.2h1.6v6.4h-1.5v-1.2c-.4.7-1.3,1.3-2.4,1.3-1.8,0-3.2-1.5-3.2-3.3s1.3-3.3,3.2-3.3ZM136.7,117.8c1.1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.9.8-1.9,1.9.8,1.9,1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M149.1,115.4v3.8h-1.6v-3c0-1.5-.5-2-1.4-2s-1.7.8-1.8,1.9v3.2h-1.6v-6.4h1.5v.9c.7-.6,1.5-1.1,2.5-1.1,1.5,0,2.3,1,2.3,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M151.3,116c0-1.8,1.4-3.3,3.4-3.3s3.4,1.5,3.4,3.3-1.4,3.3-3.4,3.3-3.4-1.5-3.4-3.3ZM156.6,116c0-1-.8-1.9-1.9-1.9s-1.9.8-1.9,1.9.8,1.9,1.9,1.9,1.9-.8,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M168.8,112.7c1.1,0,2,.6,2.3,1.3v-4.3h1.6v9.5h-1.5v-1.2c-.4.7-1.3,1.3-2.4,1.3-1.8,0-3.2-1.5-3.2-3.3s1.3-3.3,3.2-3.3ZM169.1,117.8c1.1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.9.8-1.9,1.9.8,1.9,1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M181.5,116.5h-4.8c0,.8.6,1.5,1.8,1.5s1.3-.4,1.6-.9l1.4.2c-.2.9-1.2,2.1-2.9,2.1s-3.3-1.5-3.3-3.4,1.3-3.3,3.2-3.3,3.2,1.6,3.2,3.4v.4ZM176.7,115.4h3.3c0-.7-.7-1.3-1.6-1.3s-1.6.6-1.6,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M192,116.4h-1.6v2.8h-1.6v-8.9h3.4c1.6,0,3.1,1.2,3.1,3.1s-.8,2.3-1.8,2.8l1.9,3.1h-1.8l-1.7-2.8ZM190.4,114.9h1.8c.9,0,1.6-.6,1.6-1.6s-.7-1.6-1.6-1.6h-1.8v3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M203.6,116.5h-4.8c0,.8.6,1.5,1.8,1.5s1.3-.4,1.6-.9l1.4.2c-.2.9-1.2,2.1-2.9,2.1s-3.3-1.5-3.3-3.4,1.3-3.3,3.2-3.3,3.2,1.6,3.2,3.4v.4ZM198.8,115.4h3.3c0-.7-.7-1.3-1.6-1.3s-1.6.6-1.6,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M209.2,114.1c-.9,0-1.9.7-1.9,1.9s.9,1.9,1.9,1.9,1.1-.2,1.6-.7v1.5c-.4.4-1.1.7-1.9.7-1.9,0-3.3-1.5-3.3-3.3s1.4-3.3,3.3-3.3,1.4.3,1.9.7v1.5c-.5-.5-1-.7-1.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M219.5,112.8v6.4h-1.5v-.9c-.7.6-1.5,1.1-2.5,1.1-1.5,0-2.3-1-2.3-2.7v-3.8h1.6v3c0,1.5.5,2,1.4,2s1.8-.9,1.8-1.9v-3.1h1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M222.1,112.8h1.5v1.2c.4-.7,1.3-1.3,2.4-1.3,1.8,0,3.2,1.5,3.2,3.3s-1.3,3.3-3.2,3.3-1.9-.6-2.3-1.3v4.1h-1.6v-9.3ZM225.7,117.8c1.1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.9.8-1.9,1.9.8,1.9,1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M237.5,116.5h-4.8c0,.8.6,1.5,1.8,1.5s1.3-.4,1.6-.9l1.4.2c-.2.9-1.2,2.1-2.9,2.1s-3.3-1.5-3.3-3.4,1.3-3.3,3.2-3.3,3.2,1.6,3.2,3.4v.4ZM232.6,115.4h3.3c0-.7-.7-1.3-1.6-1.3s-1.6.6-1.6,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M243.5,112.9l-.2,1.3c-.1,0-.4-.2-.6-.2-.8,0-1.3.9-1.3,2.2v2.8h-1.6v-6.4h1.5v.7c.5-.5.9-.8,1.5-.8s.6.1.8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M248.2,112.7c1.1,0,2,.6,2.3,1.3v-1.2h1.6v6.4h-1.5v-1.2c-.4.7-1.3,1.3-2.4,1.3-1.8,0-3.2-1.5-3.2-3.3s1.3-3.3,3.2-3.3ZM248.4,117.8c1.1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.9.8-1.9,1.9.8,1.9,1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M255.8,116c0,1.1.9,1.9,1.9,1.9s1.1-.2,1.6-.7v1.5c-.4.3-.9.6-1.5.6l-.3.5c.8,0,1.3.3,1.3.9,0,1.2-2.1,1.1-2.7,1.1l.3-.7c.9,0,1.6,0,1.6-.4s-.3-.4-.8-.4h-.9s.5-1.1.5-1.1c-1.5-.3-2.6-1.7-2.6-3.3s1.4-3.3,3.3-3.3,1.4.3,1.9.7v1.5c-.5-.5-1-.7-1.6-.7-.9,0-1.9.7-1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M264.6,112.7c1.1,0,2,.6,2.3,1.3v-1.2h1.6v6.4h-1.5v-1.2c-.4.7-1.3,1.3-2.4,1.3-1.8,0-3.2-1.5-3.2-3.3s1.3-3.3,3.2-3.3ZM263.7,109.5c1,0,1.3.9,2.1.9s.7-.2.7-.7l1.3.3c0,.9-.5,1.7-1.6,1.7s-1.3-.8-2.1-.8-.7.3-.7.7l-1.3-.3c0-.9.5-1.7,1.6-1.7ZM264.9,117.8c1.1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.9.8-1.9,1.9.8,1.9,1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M270.6,116c0-1.8,1.4-3.3,3.4-3.3s3.4,1.5,3.4,3.3-1.4,3.3-3.4,3.3-3.4-1.5-3.4-3.3ZM275.9,116c0-1-.8-1.9-1.9-1.9s-1.9.8-1.9,1.9.8,1.9,1.9,1.9,1.9-.8,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M127.5,131.2h-4.8c0,.8.6,1.5,1.8,1.5s1.3-.4,1.6-.9l1.4.2c-.2.9-1.2,2.1-2.9,2.1s-3.3-1.5-3.3-3.4,1.3-3.3,3.2-3.3,3.2,1.6,3.2,3.4v.4ZM122.7,130.1h3.3c0-.7-.7-1.3-1.6-1.3s-1.6.6-1.6,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M138,131.1h-1.6v2.8h-1.6v-8.9h3.4c1.6,0,3.1,1.2,3.1,3.1s-.8,2.3-1.8,2.8l1.9,3.1h-1.8l-1.7-2.8ZM136.4,129.7h1.8c.9,0,1.6-.6,1.6-1.6s-.7-1.6-1.6-1.6h-1.8v3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M149.6,131.2h-4.8c0,.8.6,1.5,1.8,1.5s1.3-.4,1.6-.9l1.4.2c-.2.9-1.2,2.1-2.9,2.1s-3.3-1.5-3.3-3.4,1.3-3.3,3.2-3.3,3.2,1.6,3.2,3.4v.4ZM144.8,130.1h3.3c0-.7-.7-1.3-1.6-1.3s-1.6.6-1.6,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M153.1,132c0,.5.6.8,1.3.8s1-.2,1-.6-.5-.6-1.8-1c-1.1-.3-1.9-.9-1.9-1.9s1.1-1.8,2.4-1.8,2.5.9,2.6,2h-1.6c0-.5-.5-.7-1-.7s-.9.2-.9.6.5.5,1.8,1c1.4.5,1.9,1.2,1.9,2,0,1.2-1.2,1.8-2.6,1.8s-2.8-.7-2.8-2.1h1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M159.2,125.9c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8-.8-.4-.8-.8ZM160.8,133.9h-1.6v-6.4h1.6v6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M165,133.9h-1.6v-9.5h1.6v9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M167.5,125.9c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8-.8-.4-.8-.8ZM169.1,133.9h-1.6v-6.4h1.6v6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M177.9,131.2h-4.8c0,.8.6,1.5,1.8,1.5s1.3-.4,1.6-.9l1.4.2c-.2.9-1.2,2.1-2.9,2.1s-3.3-1.5-3.3-3.4,1.3-3.3,3.2-3.3,3.2,1.6,3.2,3.4v.4ZM174,126.2h-1.4l1.5-2h1.2l1.5,2h-1.4l-.7-1.1-.7,1.1ZM173,130.1h3.3c0-.7-.7-1.3-1.6-1.3s-1.6.6-1.6,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M186.4,130.2v3.8h-1.6v-3c0-1.5-.5-2-1.4-2s-1.7.8-1.8,1.9v3.2h-1.6v-6.4h1.5v.9c.7-.6,1.5-1.1,2.5-1.1,1.5,0,2.3,1,2.3,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M192.2,128.9c-.9,0-1.9.7-1.9,1.9s.9,1.9,1.9,1.9,1.1-.2,1.6-.7v1.5c-.4.4-1.1.7-1.9.7-1.9,0-3.3-1.5-3.3-3.3s1.4-3.3,3.3-3.3,1.4.3,1.9.7v1.5c-.5-.5-1-.7-1.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M196.1,125.9c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8-.8-.4-.8-.8ZM197.6,133.9h-1.6v-6.4h1.6v6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M203.2,127.4c1.1,0,2,.6,2.3,1.3v-1.2h1.6v6.4h-1.5v-1.2c-.4.7-1.3,1.3-2.4,1.3-1.8,0-3.2-1.5-3.2-3.3s1.3-3.3,3.2-3.3ZM203.5,132.6c1.1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.9.8-1.9,1.9.8,1.9,1.9,1.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 656.6,
    y: 45.8,
    width: 121.9,
    height: 82.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M717.5,87.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 658.9,
    y: 48,
    width: 117.2,
    height: 78.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M717.5,87.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "715 65.1 717.5 63.3 719.9 65.1 719 62.2 721.5 60.3 718.4 60.3 717.5 57.4 716.5 60.3 713.4 60.3 715.9 62.2 715 65.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "702.2 68.5 704.7 66.7 707.1 68.5 706.2 65.6 708.7 63.8 705.6 63.8 704.7 60.8 703.7 63.8 700.6 63.8 703.1 65.6 702.2 68.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "695.3 70.2 694.4 73.2 691.3 73.2 693.8 75 692.8 77.9 695.3 76.1 697.8 77.9 696.8 75 699.4 73.2 696.3 73.2 695.3 70.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "691.9 88.9 694.3 90.7 693.4 87.8 695.9 86 692.8 86 691.9 83 690.9 86 687.8 86 690.3 87.8 689.4 90.7 691.9 88.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "696.3 98.8 695.3 95.8 694.4 98.8 691.3 98.8 693.8 100.6 692.8 103.5 695.3 101.7 697.8 103.5 696.8 100.6 699.4 98.8 696.3 98.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "705.6 108.2 704.7 105.2 703.7 108.2 700.7 108.2 703.2 110 702.2 112.9 704.7 111.1 707.2 112.9 706.2 110 708.7 108.2 705.6 108.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "718.4 111.6 717.5 108.6 716.5 111.6 713.4 111.6 715.9 113.4 715 116.3 717.5 114.5 719.9 116.3 719 113.4 721.5 111.6 718.4 111.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "731.2 108.2 730.3 105.2 729.3 108.2 726.2 108.2 728.7 110 727.8 112.9 730.3 111.1 732.7 112.9 731.8 110 734.3 108.2 731.2 108.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "740.6 98.8 739.6 95.8 738.7 98.8 735.6 98.8 738.1 100.6 737.2 103.5 739.6 101.7 742.1 103.5 741.2 100.6 743.7 98.8 740.6 98.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "747.1 85.9 744 85.9 743 83 742.1 85.9 739 85.9 741.5 87.7 740.6 90.6 743 88.8 745.5 90.6 744.6 87.7 747.1 85.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "737.2 77.9 739.6 76 742.1 77.9 741.2 74.9 743.7 73.1 740.6 73.1 739.6 70.2 738.7 73.1 735.6 73.1 738.1 74.9 737.2 77.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "730.3 60.8 729.3 63.8 726.3 63.8 728.8 65.6 727.8 68.5 730.3 66.7 732.8 68.5 731.8 65.6 734.3 63.8 731.2 63.8 730.3 60.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M790.6,65.5v-17.5h12v3h-8.4v4.1h7.3v3h-7.3v7.4h-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M805.5,51.1v-3.1h3.3v3.1h-3.3ZM805.5,65.5v-12.6h3.3v12.6h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M823.7,65.5h-3.3v-6.5c0-1.4,0-2.2-.2-2.6-.1-.4-.4-.7-.7-.9-.3-.2-.7-.3-1.2-.3s-1.1.2-1.6.5c-.5.3-.8.7-.9,1.3s-.3,1.5-.3,2.9v5.7h-3.3v-12.6h3.1v1.9c1.1-1.4,2.5-2.1,4.2-2.1s1.4.1,2,.4c.6.3,1.1.6,1.4,1,.3.4.5.9.7,1.4s.2,1.3.2,2.3v7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M829.6,56.7l-3-.5c.3-1.2.9-2.1,1.8-2.7.8-.6,2.1-.9,3.7-.9s2.6.2,3.3.5c.7.4,1.2.8,1.5,1.3.3.5.4,1.5.4,3v3.9c0,1.1,0,1.9.1,2.5.1.5.3,1.1.6,1.7h-3.3c0-.2-.2-.6-.3-1,0-.2,0-.3-.1-.4-.6.6-1.2,1-1.8,1.3-.7.3-1.3.4-2.1.4-1.3,0-2.3-.4-3.1-1.1-.7-.7-1.1-1.6-1.1-2.7s.2-1.4.5-1.9c.3-.6.8-1,1.4-1.3.6-.3,1.5-.6,2.7-.8,1.6-.3,2.6-.6,3.3-.8v-.3c0-.6-.2-1.1-.5-1.4-.3-.3-.9-.4-1.8-.4s-1.1.1-1.4.4-.6.6-.8,1.2ZM834.1,59.4c-.4.1-1.1.3-2,.5-.9.2-1.5.4-1.8.6-.4.3-.7.7-.7,1.2s.2.9.5,1.2c.3.3.8.5,1.3.5s1.2-.2,1.7-.6c.4-.3.7-.7.8-1.1,0-.3.1-.8.1-1.6v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M852.2,65.5h-3.3v-6.5c0-1.4,0-2.2-.2-2.6-.1-.4-.4-.7-.7-.9-.3-.2-.7-.3-1.2-.3s-1.1.2-1.6.5c-.5.3-.8.7-.9,1.3s-.3,1.5-.3,2.9v5.7h-3.3v-12.6h3.1v1.9c1.1-1.4,2.5-2.1,4.2-2.1s1.4.1,2,.4c.6.3,1.1.6,1.4,1,.3.4.5.9.7,1.4s.2,1.3.2,2.3v7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M866.6,56.6l-3.3.6c-.1-.7-.4-1.2-.8-1.5-.4-.3-.9-.5-1.5-.5s-1.5.3-2,.9c-.5.6-.7,1.5-.7,2.9s.3,2.6.8,3.2,1.2.9,2,.9,1.2-.2,1.6-.5c.4-.4.7-1,.9-1.9l3.3.6c-.3,1.5-1,2.6-2,3.4-1,.8-2.3,1.2-3.9,1.2s-3.3-.6-4.4-1.8-1.6-2.8-1.6-4.8.6-3.7,1.7-4.9c1.1-1.2,2.6-1.7,4.5-1.7s2.8.3,3.7,1c.9.7,1.6,1.7,2,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M869.1,51.1v-3.1h3.3v3.1h-3.3ZM869.1,65.5v-12.6h3.3v12.6h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M878.4,56.7l-3-.5c.3-1.2.9-2.1,1.8-2.7.8-.6,2.1-.9,3.7-.9s2.6.2,3.3.5c.7.4,1.2.8,1.5,1.3.3.5.4,1.5.4,3v3.9c0,1.1,0,1.9.1,2.5.1.5.3,1.1.6,1.7h-3.3c0-.2-.2-.6-.3-1,0-.2,0-.3-.1-.4-.6.6-1.2,1-1.8,1.3-.7.3-1.3.4-2.1.4-1.3,0-2.3-.4-3.1-1.1-.7-.7-1.1-1.6-1.1-2.7s.2-1.4.5-1.9c.3-.6.8-1,1.4-1.3.6-.3,1.5-.6,2.7-.8,1.6-.3,2.6-.6,3.3-.8v-.3c0-.6-.2-1.1-.5-1.4-.3-.3-.9-.4-1.8-.4s-1.1.1-1.4.4-.6.6-.8,1.2ZM882.9,59.4c-.4.1-1.1.3-2,.5-.9.2-1.5.4-1.8.6-.4.3-.7.7-.7,1.2s.2.9.5,1.2c.3.3.8.5,1.3.5s1.2-.2,1.7-.6c.4-.3.7-.7.8-1.1,0-.3.1-.8.1-1.6v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M901.1,65.5h-3.1v-1.9c-.5.7-1.1,1.3-1.8,1.6-.7.4-1.4.5-2.1.5-1.5,0-2.7-.6-3.7-1.8-1-1.2-1.6-2.8-1.6-4.9s.5-3.8,1.5-4.9c1-1.1,2.3-1.7,3.8-1.7s2.6.6,3.7,1.8v-6.3h3.3v17.5ZM892.1,58.9c0,1.3.2,2.3.6,2.9.5.9,1.3,1.3,2.3,1.3s1.4-.3,2-1c.5-.7.8-1.6.8-2.9s-.3-2.5-.8-3.1c-.5-.6-1.2-1-2-1s-1.5.3-2,.9c-.5.6-.8,1.6-.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M903.6,59c0-1.1.3-2.2.8-3.2.5-1,1.3-1.8,2.3-2.4,1-.5,2.1-.8,3.4-.8,1.9,0,3.5.6,4.7,1.9,1.2,1.2,1.8,2.8,1.8,4.7s-.6,3.5-1.9,4.8c-1.2,1.3-2.8,1.9-4.7,1.9s-2.3-.3-3.3-.8c-1.1-.5-1.9-1.3-2.4-2.3-.5-1-.8-2.2-.8-3.7ZM907,59.2c0,1.3.3,2.2.9,2.9.6.7,1.3,1,2.2,1s1.6-.3,2.2-1c.6-.7.9-1.6.9-2.9s-.3-2.2-.9-2.9c-.6-.7-1.3-1-2.2-1s-1.6.3-2.2,1c-.6.7-.9,1.6-.9,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M925.9,52.9h3.1v1.9c.4-.6,1-1.2,1.6-1.5.7-.4,1.5-.6,2.3-.6,1.5,0,2.7.6,3.7,1.7,1,1.2,1.5,2.8,1.5,4.8s-.5,3.8-1.5,4.9c-1,1.2-2.3,1.8-3.8,1.8s-1.3-.1-1.9-.4c-.6-.3-1.2-.8-1.8-1.4v6.4h-3.3v-17.5ZM929.2,59c0,1.4.3,2.5.8,3.1.6.7,1.3,1,2.1,1s1.4-.3,1.9-.9c.5-.6.8-1.6.8-3.1s-.3-2.3-.8-3c-.5-.6-1.2-1-2-1s-1.5.3-2,.9c-.5.6-.8,1.6-.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M948.2,61.5l3.3.6c-.4,1.2-1.1,2.2-2,2.8-.9.6-2.1,1-3.5,1-2.2,0-3.8-.7-4.9-2.2-.8-1.2-1.2-2.6-1.2-4.4s.5-3.7,1.6-4.9c1.1-1.2,2.5-1.8,4.2-1.8s3.4.6,4.5,1.9c1.1,1.2,1.6,3.1,1.6,5.7h-8.4c0,1,.3,1.8.8,2.3.5.6,1.2.8,1.9.8s1-.1,1.3-.4.6-.7.8-1.4ZM948.4,58.1c0-1-.3-1.7-.8-2.2s-1.1-.8-1.7-.8-1.3.3-1.8.8c-.5.5-.7,1.3-.7,2.2h5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M954.5,65.5v-17.5h3.3v17.5h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M963.8,56.7l-3-.5c.3-1.2.9-2.1,1.8-2.7.8-.6,2.1-.9,3.7-.9s2.6.2,3.3.5c.7.4,1.2.8,1.5,1.3.3.5.4,1.5.4,3v3.9c0,1.1,0,1.9.1,2.5.1.5.3,1.1.6,1.7h-3.3c0-.2-.2-.6-.3-1,0-.2,0-.3-.1-.4-.6.6-1.2,1-1.8,1.3-.7.3-1.3.4-2.1.4-1.3,0-2.3-.4-3.1-1.1-.7-.7-1.1-1.6-1.1-2.7s.2-1.4.5-1.9c.3-.6.8-1,1.4-1.3.6-.3,1.5-.6,2.7-.8,1.6-.3,2.6-.6,3.3-.8v-.3c0-.6-.2-1.1-.5-1.4-.3-.3-.9-.4-1.8-.4s-1.1.1-1.4.4-.6.6-.8,1.2ZM968.2,59.4c-.4.1-1.1.3-2,.5-.9.2-1.5.4-1.8.6-.4.3-.7.7-.7,1.2s.2.9.5,1.2c.3.3.8.5,1.3.5s1.2-.2,1.7-.6c.4-.3.7-.7.8-1.1,0-.3.1-.8.1-1.6v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M790.6,77.3h3.5v9.5c0,1.5,0,2.5.1,2.9.2.7.5,1.3,1.1,1.7.6.4,1.3.6,2.3.6s1.8-.2,2.3-.6c.5-.4.8-.9.9-1.5.1-.6.2-1.6.2-3v-9.7h3.5v9.2c0,2.1,0,3.6-.3,4.4-.2.9-.5,1.6-1.1,2.2-.5.6-1.2,1.1-2.1,1.4-.9.4-2,.5-3.4.5s-2.9-.2-3.8-.6c-.9-.4-1.5-.9-2-1.5-.5-.6-.8-1.3-1-1.9-.2-1-.3-2.5-.3-4.4v-9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M819.7,94.8h-3.3v-6.5c0-1.4,0-2.2-.2-2.6-.1-.4-.4-.7-.7-.9-.3-.2-.7-.3-1.2-.3s-1.1.2-1.6.5c-.5.3-.8.7-.9,1.3s-.3,1.5-.3,2.9v5.7h-3.3v-12.6h3.1v1.9c1.1-1.4,2.5-2.1,4.2-2.1s1.4.1,2,.4c.6.3,1.1.6,1.4,1,.3.4.5.9.7,1.4s.2,1.3.2,2.3v7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M823.1,80.4v-3.1h3.3v3.1h-3.3ZM823.1,94.8v-12.6h3.3v12.6h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M832.3,86l-3-.5c.3-1.2.9-2.1,1.8-2.7.8-.6,2.1-.9,3.7-.9s2.6.2,3.3.5c.7.4,1.2.8,1.5,1.3.3.5.4,1.5.4,3v3.9c0,1.1,0,1.9.1,2.5.1.5.3,1.1.6,1.7h-3.3c0-.2-.2-.6-.3-1,0-.2,0-.3-.1-.4-.6.6-1.2,1-1.8,1.2-.7.3-1.3.4-2.1.4-1.3,0-2.3-.4-3.1-1.1-.7-.7-1.1-1.6-1.1-2.7s.2-1.4.5-1.9c.3-.6.8-1,1.4-1.3.6-.3,1.5-.6,2.7-.8,1.6-.3,2.6-.6,3.3-.8v-.3c0-.6-.2-1.1-.5-1.4-.3-.3-.9-.4-1.8-.4s-1.1.1-1.4.4-.6.6-.8,1.2ZM832.3,80.4h-1.5c0-.2,0-.3,0-.4,0-.8.2-1.5.6-1.9.4-.4.9-.7,1.6-.7s.5,0,.8,0c.2,0,.7.2,1.3.5.6.3,1.1.4,1.5.4s.5,0,.6-.2c.2-.2.3-.4.3-.8h1.5c0,1.1-.2,1.8-.6,2.3-.4.5-.9.7-1.5.7s-.5,0-.8,0c-.2,0-.6-.2-1.4-.5-.7-.3-1.3-.4-1.6-.4s-.5,0-.6.2c-.1.2-.2.4-.2.8ZM836.8,88.7c-.4.1-1.1.3-2,.5-.9.2-1.5.4-1.8.6-.4.3-.7.7-.7,1.2s.2.9.5,1.2c.3.3.8.5,1.3.5s1.2-.2,1.7-.6c.4-.3.7-.7.8-1.1,0-.3.1-.8.1-1.6v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M842.6,88.3c0-1.1.3-2.2.8-3.2.5-1,1.3-1.8,2.3-2.4,1-.5,2.1-.8,3.4-.8,1.9,0,3.5.6,4.7,1.9,1.2,1.2,1.8,2.8,1.8,4.7s-.6,3.5-1.9,4.8c-1.2,1.3-2.8,1.9-4.7,1.9s-2.3-.3-3.3-.8c-1.1-.5-1.9-1.3-2.4-2.3-.5-1-.8-2.2-.8-3.7ZM846,88.4c0,1.3.3,2.2.9,2.9.6.7,1.3,1,2.2,1s1.6-.3,2.2-1c.6-.7.9-1.6.9-2.9s-.3-2.2-.9-2.9c-.6-.7-1.3-1-2.2-1s-1.6.3-2.2,1c-.6.7-.9,1.6-.9,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M865.1,94.8v-17.5h12.9v3h-9.4v3.9h8.8v2.9h-8.8v4.7h9.8v2.9h-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M889.6,94.8v-1.9c-.5.7-1.1,1.2-1.8,1.6-.7.4-1.5.6-2.4.6s-1.6-.2-2.3-.6c-.7-.4-1.2-.9-1.5-1.6-.3-.7-.5-1.6-.5-2.8v-8h3.3v5.8c0,1.8,0,2.9.2,3.3s.3.7.7,1c.3.2.7.4,1.2.4s1.1-.2,1.5-.5c.5-.3.8-.7.9-1.2.2-.5.2-1.6.2-3.4v-5.3h3.3v12.6h-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M899.4,94.8h-3.3v-12.6h3.1v1.8c.5-.8,1-1.4,1.4-1.7.4-.3.9-.4,1.4-.4s1.5.2,2.2.6l-1,2.9c-.6-.4-1.1-.5-1.6-.5s-.9.1-1.2.4c-.3.3-.6.7-.8,1.4-.2.7-.3,2.1-.3,4.2v3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M904.9,88.3c0-1.1.3-2.2.8-3.2.5-1,1.3-1.8,2.3-2.4,1-.5,2.1-.8,3.4-.8,1.9,0,3.5.6,4.7,1.9,1.2,1.2,1.8,2.8,1.8,4.7s-.6,3.5-1.9,4.8c-1.2,1.3-2.8,1.9-4.7,1.9s-2.3-.3-3.3-.8c-1.1-.5-1.9-1.3-2.4-2.3-.5-1-.8-2.2-.8-3.7ZM908.4,88.4c0,1.3.3,2.2.9,2.9.6.7,1.3,1,2.2,1s1.6-.3,2.2-1c.6-.7.9-1.6.9-2.9s-.3-2.2-.9-2.9c-.6-.7-1.3-1-2.2-1s-1.6.3-2.2,1c-.6.7-.9,1.6-.9,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M920.5,82.1h3.1v1.9c.4-.6,1-1.2,1.6-1.5.7-.4,1.5-.6,2.3-.6,1.5,0,2.7.6,3.7,1.7,1,1.2,1.5,2.8,1.5,4.8s-.5,3.8-1.5,4.9c-1,1.2-2.3,1.8-3.8,1.8s-1.3-.1-1.9-.4c-.6-.3-1.2-.8-1.8-1.4v6.4h-3.3v-17.5ZM923.8,88.2c0,1.4.3,2.5.8,3.1.6.7,1.3,1,2.1,1s1.4-.3,1.9-.9c.5-.6.8-1.6.8-3.1s-.3-2.3-.8-3c-.5-.6-1.2-1-2-1s-1.5.3-2,.9c-.5.6-.8,1.6-.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M942.8,90.7l3.3.6c-.4,1.2-1.1,2.2-2,2.8-.9.6-2.1,1-3.5,1-2.2,0-3.8-.7-4.9-2.2-.8-1.2-1.2-2.6-1.2-4.4s.5-3.7,1.6-4.9c1.1-1.2,2.5-1.8,4.2-1.8s3.4.6,4.5,1.9c1.1,1.2,1.6,3.1,1.6,5.7h-8.4c0,1,.3,1.8.8,2.3.5.6,1.2.8,1.9.8s1-.1,1.3-.4.6-.7.8-1.4ZM943,87.3c0-1-.3-1.7-.8-2.2s-1.1-.8-1.7-.8-1.3.3-1.8.8c-.5.5-.7,1.3-.7,2.2h5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M949.1,80.4v-3.1h3.3v3.1h-3.3ZM949.1,94.8v-12.6h3.3v12.6h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M958.3,86l-3-.5c.3-1.2.9-2.1,1.8-2.7.8-.6,2.1-.9,3.7-.9s2.6.2,3.3.5c.7.4,1.2.8,1.5,1.3.3.5.4,1.5.4,3v3.9c0,1.1,0,1.9.1,2.5.1.5.3,1.1.6,1.7h-3.3c0-.2-.2-.6-.3-1,0-.2,0-.3-.1-.4-.6.6-1.2,1-1.8,1.2-.7.3-1.3.4-2.1.4-1.3,0-2.3-.4-3.1-1.1-.7-.7-1.1-1.6-1.1-2.7s.2-1.4.5-1.9c.3-.6.8-1,1.4-1.3.6-.3,1.5-.6,2.7-.8,1.6-.3,2.6-.6,3.3-.8v-.3c0-.6-.2-1.1-.5-1.4-.3-.3-.9-.4-1.8-.4s-1.1.1-1.4.4-.6.6-.8,1.2ZM962.8,88.7c-.4.1-1.1.3-2,.5-.9.2-1.5.4-1.8.6-.4.3-.7.7-.7,1.2s.2.9.5,1.2c.3.3.8.5,1.3.5s1.2-.2,1.7-.6c.4-.3.7-.7.8-1.1,0-.3.1-.8.1-1.6v-.7Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-87",
    transform: "translate(789 126.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NextGenerationEU"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 28.4,
    y: 54.5,
    width: 40.2,
    height: 32.7,
    transform: "translate(-22.3 119.4) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 73.7,
    y: 88.9,
    width: 40.2,
    height: 43.9,
    transform: "translate(187.5 221.7) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 44.5,
    y: 42.2,
    width: 67.2,
    height: 82
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95,123.7c-.1.1-.2.3-.3.4h0c0-.2.2-.3.3-.4M97.3,120.7c-.6.8-1.2,1.6-1.9,2.4,0,0,0,0,0,0,6.7-8.6,9-19.2,3.2-27.9-5.9-9-22.3-8.2-28.2-21.3-5.9-13.1-8.7-23.4-24.9-18.3h0c11.9-4.9,17,1.3,19.4,5.1,2.3,3.6,4.1,8.1,6.2,12.9,2.6,5.7,7.2,8.7,12.7,11.3,4.7,2.2,10.6,4.3,14.1,8.2.5.5.9,1.1,1.3,1.7,2.7,4,6.2,14.2-1.9,25.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M18.7,94.1v46.5-46.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 18.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 19.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 19.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 20.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 20.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 21.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 22.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 23.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 23.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 24.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 24.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 25.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 26,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 26.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 27.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 27.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 28.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 28.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 29.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 30,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 30.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 31.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 31.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 32.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 32.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 33.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 34,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 34.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 35.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 35.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 36.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 36.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 37.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 38,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 38.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 39.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 39.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 40.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 40.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 41.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 41.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 42.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 43.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 43.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 44.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 44.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 45.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 45.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 46.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 47,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 47.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 48.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 48.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 49.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 49.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 50.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 51,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 51.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 52.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 52.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 53.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 53.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 54.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 55,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 55.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 56.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 56.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 57.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 57.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 58.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 58.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 59.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 60.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 60.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 61.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 61.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 62.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 62.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 63.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 64,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 64.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 65.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 65.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 66.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 66.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 67.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 68,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 68.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 69.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 69.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 70.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 70.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 71.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 72,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 72.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 73.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 73.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 74.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 74.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 75.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 75.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 76.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 77.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 78.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 78.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 80.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 81,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 81.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 82.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 82.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 83.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 83.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 85,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 85.6,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 86.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 86.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 87.3,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 87.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 88.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 89,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 89.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 90.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 90.7,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 91.2,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 91.8,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 92.4,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 92.9,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 93.5,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 94.1,
    y: 94.1,
    width: 0.6,
    height: 46.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M94.6,140.6v-46.5,46.5Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 17.3,
    y: 97.9,
    width: 74.7,
    height: 45.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 18.7,
    y: 56.3,
    width: 38.7,
    height: 82.7,
    transform: "translate(76 195.3) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M62,139c-23.9,0-43.3-19.4-43.3-43.3,0,12.4,10.8,8.7,22.3,5.4-.7,15.4-8.5,35.2,21,37.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.9,115.9h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M94.7,124s0,0,0,0c-1.1.9-5.8,4.5-10,2.3-4.1-2.1-6.6-7.4-7.6-9.5-.7.4-1.3.7-2,1,0,0,0,0,0,0,4.5,7.8,9.2,13.9,17,8.4.8-.6,1.7-1.3,2.6-2.1h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.8,58.5c.4-.2.7-.4,1.1-.6-15.1,11.1-2.4,23.7-.2,36.7,2.7,15.7-12.6,41.4,21.2,44.4-15.6,0-20.1-7.6-21.5-10.7-2.4-5.4-1.8-12.1-1.1-17.9.3-2.8.7-5.5.8-8.3.2-2.4.2-5-.2-7.4-.5-3-1.6-6-2.7-8.8-1.7-4.4-4-9.4-4.4-14.2-.4-5.3,2.5-10.3,6.9-13.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41,101.1c6.9-2,14-3.8,19.2-1.8,14.1,5.3,17.2,41.2,34.3,25-8.4,9.3-14.4,2.5-17-1.2-2.2-3.1-4-6.6-5.9-9.9-2.6-4.6-6.4-11.3-11.6-13.2-5.1-1.9-12.4.1-17.5,1.5-.5.1-1,.3-1.5.4,0-.3,0-.5,0-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M41,101.1c3.1-.9,6.2-1.7,9.2-2.2-3.6,13.8-13.5,35,11.7,40.1-29.5-2.7-21.7-22.5-21-37.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M41,101.1c.9-.2,1.7-.5,2.6-.7.3,3.4-1.8,12-1.8,19.5,0,11.7,7.4,17.2,20.2,19.1-29.5-2.7-21.7-22.5-21-37.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M336.2,45.3c-17.7,5.7-26.7,20.7-26.7,43.9v35.2s3-22.6,26.7-29.1v-50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M338.2,51.9s13.5-5.1,32.6-6.2c0,0,0,16-.6,29-1.6,41.1-38.3,20-56.3,41.8,3.6-9.5,15.9-16.2,24.3-17.9v-46.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M333.2,110.6s-19.5,1.6-21.2,12.7c-1.3,8.7,21.2,9,21.2,9v-21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M310.4,77.8c4-9.4,10.9-19.1,25.8-25.1v-7.4c-14.6,4.7-23.3,15.8-25.8,32.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M322.3,67.6h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0c0,0,.2,0,.3,0h0c0,0,.2,0,.3,0h0s0,0,0,0h0c0,0,.1,0,.2,0h0s0,0,0,0h0c0,0,.1,0,.2,0h0s0,0,0,0h0c0,0,.1,0,.2,0h0c.2,0,.5.1.8.2h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.2,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0v-1c-.1,0-.3,0-.4,0-.1,0-.3,0-.4,0h0s0,0-.1,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.3,0-.6-.2-.8-.3h0s0,0,0,0t0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0t0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,.1,0h0c0,0,.1,0,.2,0h0s0,0,.1,0h0c.5-.1,1-.3,1.6-.4v-.5s0,0,0,0c0,0,0,0,0,0v-.6c-.3.3-.6.6-.8.8-.7.2-1.3.4-1.8.6,2.9-3.8,7.4-6.4,12.4-6.7v-.5c-5.4.3-10.2,3.2-13.2,7.4-.3,0-.4,0-.6.2,0,0,0,0,0,0l-.3.5s0,.1,0,.2c0-.2.1-.3.3-.4ZM323.3,67.1s0,0,0,0c0,0,0,0,0,0h0ZM335.8,61.7c-3,.3-5.7,1.4-8,3.1h-.7c2.4-2,5.5-3.2,8.8-3.5v.5ZM320.7,70.6c0-.1,0-.3,0-.3l.2-.4s0,0,0,0c0,0,.2,0,.3,0h0s0,0,0,0c.1,0,.2,0,.4,0h0c.3,0,.6.1,1,.2.1,0,.3,0,.4.1h0c0,0,.1,0,.2,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0v.5c-1.2-.6-2.3-1-3.2-1.3h0c-.1,0-.3,0-.4-.1h0c-.4-.1-.7-.2-1-.2,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h-.1s-.1,0-.2,0h0c-.2,0-.3,0-.4.4ZM326,88.4c2.5,2.6,5.9,4.2,9.7,4.6v.5c-4.8-.4-9-2.9-11.7-6.7.3,0,.5,0,.6,0,.4.5.9,1.1,1.3,1.5,0,0,0,0,0,0h0ZM337.7,59.7h0v-.3s0,0,0,0c0,0,0,0,0,0h.4s0,0,0,0v.3c5.6.3,10.5,3.2,13.5,7.5.2.1.4.2.5.3,0,0,0,0,0,0,0,0,.3.5.3.6,0,0,0,.2,0,.2,0,0,0,0,0-.2,0,0-.1,0-.2-.1h0s0,0,0,0h0s0,0,0,0h0c-.2-.1-.5-.3-.8-.4h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0-.1,0c0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0t0,0c-.3,0-.6-.2-.9-.2h0s0,0-.2,0h0s0,0-.1,0h0s0,0-.1,0h0c0,0,0,0-.1,0h0v-.5h0v-.6c.3.3.6.6.8.8.7.2,1.3.4,1.8.6-3-3.8-7.5-6.4-12.7-6.7v1c3.5.2,6.6,1.5,9.2,3.6h-.7c-2.4-1.8-5.3-2.9-8.4-3.1v3.1h-.5v-5ZM352.7,68.8c.2,0,.3.2.4.2,0,0,.2.4.3.5,0,0,0,.2-.1.2,0,0,.1-.1,0-.2,0,0-.1,0-.2,0h0s0,0,0,0c-.5-.3-1.2-.5-2.1-.8h0c-.2,0-.4-.1-.7-.2h0c-.6-.2-1.3-.3-2-.5v-.5c0,0,.2,0,.3,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c.2,0,.5.1.7.2,0,0,0,0,0,0h0c0,0,.1,0,.2,0h0c.1,0,.2,0,.3,0h0c.3,0,.6.2.9.3h0c.3,0,.5.2.7.3,0,0,0,0,0,0h0ZM336.2,59.7s0,0,0,0c0,0,0,0,0,0ZM319.3,76.9v-.5s0,0,0,0c0-.1.1-.2.3-.3.1-1.9.5-3.7,1.2-5.4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0c0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,.2,0,.4.1-.7,1.6-1.2,3.4-1.3,5.3.3-.2.6-.3,1.1-.5.2-1.5.6-2.9,1.1-4.2.1.1.2.2.3.4,0,.2-.2.5-.3.7,0,0,0,0,0,0-.3.9-.6,1.9-.7,2.9,1.1-.4,2.5-.8,4-1.1.2,0,.4,0,.6-.1v.5c-.2,0-.3,0-.5,0,0,0,0,0-.1,0h0s0,0-.1,0c0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0c0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0c0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0c0,0-.2,0-.3,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0c0,0-.2,0-.2,0h0s0,0-.1,0h0s0,0-.1,0h0c0,0-.2,0-.2,0,0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0-.1,0h0c-.2,0-.3.1-.5.2h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0-.1,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0-.1,0h0s0,0,0,0h0s0,0-.1,0h0s0,0,0,0h0s0,0,0,0h0c-.2.1-.3.2-.4.3,0,0,0,0,0,0h0c0,0-.2.2-.2.3,0,0,0,0,0-.1ZM336.2,61.2v-1.8s0,0,0,0h.4s0,0,0,0v.2h0v5.1h-.5v-3.6ZM351.5,87.8c0,.1,0,.2,0,.3,0,0-.1.2-.2.3,0,0-.1.2-.3.2,0,0,.3,0,.2-.5h0s0,0,0-.1c0,0-.1-.2-.2-.3h0c-.2-.2-.4-.5-.7-.8h0c-.1-.1-.2-.2-.3-.3h0c-.7-.6-1.6-1.4-2.8-2.3,0-.1.1-.3.2-.5h0c1.4,1,2.5,2,3.3,2.7h0c0,0,.1.1.2.2,0,0,0,0,0,0,0,0,0,0,0,0t0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0t0,0s0,0,0,0c0,0,0,0,0,0,.1.2.2.3.3.4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0ZM351,88.3c0,0,0,.1-.1.2h0s0,0-.1.1c-3,3.7-7.5,6.1-12.6,6.4v.3s0,0,0,0c0,0,0,0,0,0h-.4s0,0,0,0h0v-4.8c.2,0,.3,0,.5,0v2.6c3.9-.3,7.5-1.9,10.1-4.5h0s0,0,0,0c0,0,0,0,.1-.1,0,0,0,0,0,0,.3-.3.6-.7.9-1,.2,0,.3,0,.5.1-2.8,3.4-6.9,5.7-11.6,6v1c5.1-.3,9.6-2.8,12.5-6.5.2.1.3.2.3.3ZM354.8,78.5c0,0,0,.2,0,.2h0c-.2,2.3-.8,4.4-1.8,6.4.1.2.1.4,0,.6,0,0-.1.2-.2.3,0,.1,0,.2-.2.2,0,0,.2-.2.2-.5h0s0,0,0-.1h0c0,0,0-.1-.1-.2-.1-.2-.3-.4-.5-.6h0s0,0,0,0h0s0,0,0,0h0c-.2-.2-.4-.5-.7-.7,0,0,0,0,0,0,0,0,0,0,0,0h0c0,0-.2-.2-.3-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.2-.2-.3-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.2-.2-.3-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0c0,0-.1-.1-.2-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0t0,0s0,0-.1,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0-.2,0-.4,0-.6,1.4,1.1,2.6,2,3.5,2.9.5-1.3.9-2.6,1.1-4.1h0s0,0,0,0h0c0,0,0-.1,0-.2h0c0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0-.1h0c0-.1,0-.1,0-.2s0,0,0,0,0,0,0,0c0,0,0-.1,0-.2.1,0,.3,0,.5,0,0,2-.6,4-1.3,5.7.3.3.5.6.7.8.9-1.9,1.5-4.1,1.6-6.4.1,0,.3.1.4.2ZM355.1,76.5h0v.5c0,0,0,0,0,.1,0,0,0-.2,0-.3h0s0,0,0,0c0,0,0,0,0,0-.1-.1-.3-.2-.4-.3h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.2,0-.4-.1-.6-.2h0s0,0-.1,0t0,0s0,0-.1,0t0,0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0c0,0-.2,0-.2,0h0s0,0-.1,0c0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0c0,0-.2,0-.3,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0c0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0c0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0c0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0-.1,0c-.2,0-.3,0-.5,0v-.5c.2,0,.4,0,.6.1,1.5.3,2.9.7,4,1.1-.2-1.7-.7-3.3-1.5-4.8h0c-.2-.3-.3-.6-.5-.9,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.3,0,.5,0,1,1.8,1.7,3.8,2,5.9.4.2.8.3,1.1.5-.2-2.3-.8-4.4-1.8-6.3.2,0,.4,0,.6.1h0s0,0,0,.2h0c.9,2,1.5,4.1,1.7,6.4.1.1.2.2.3.3ZM355.1,78h0v.5c0,0,0,.1-.1.1,0,0,0-.2,0-.3,0,0,0,0,0-.1h0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0c0,0-.2-.2-.3-.2h0c-.3-.2-.6-.3-1-.5h0s0,0,0,0c-.1,0-.2,0-.3-.1,0,0,0,0,0,0-1.2-.5-2.8-.9-4.2-1.2-.2,0-.3,0-.5,0v-.5c.2,0,.4,0,.6.1,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,.1,0h0s0,0,.1,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.2,0,.3.1.5.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0t0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.2.1.3.2.5.3h0s0,0,0,0c.1,0,.2.2.2.3ZM319.6,78.3h0s0,0,0,.1c0,0-.1.2,0,.3,0,0-.1,0-.1-.1v-.5s0,0,0,0c0,0,0-.2.2-.3,0,0,0,0,0,0h0c.1-.1.3-.2.5-.3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,.1,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,0,0,.2,0,.3-.1.5-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,.1,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0h0s0,0,.1,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.4,0,.6-.1h0v.5c-.2,0-.3,0-.5,0-1.4.3-3,.7-4.2,1.2h0c-.2,0-.3.1-.4.2h0c-.4.2-.7.3-1,.5h0c-.1,0-.3.2-.4.3h0s0,0,0,0ZM322.4,87.1s0,.1,0,.2c0,0-.2,0-.2-.1,0,0-.2-.3-.2-.3h0c0,0,0-.2.1-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.2-.2.4-.3,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,.1,0h0s0,0,0,0h0c0,0,.2,0,.2-.1h0c0,0,.1,0,.2,0h0c.1,0,.3-.1.4-.2,0,0,.1,0,.2,0h0s0,0,0,0c0,0,0,0,0,0,0,0,.1,0,.2,0h0s0,0,0,0t0,0c0,0,.1,0,.2,0h0s0,0,0,0c0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c.7-.2,1.4-.4,2.1-.5,0,.2.2.3.3.5-.8.2-1.5.3-2.2.5-1.1.3-2.7.9-3.1,1.5ZM321.6,86c0,0-.1,0-.2,0,0,0-.2-.4-.2-.4,0,0,0,0,0,0,0,0,0-.2.1-.3-1-2.1-1.7-4.4-1.8-6.8.2,0,.3-.1.4-.2.1,2.4.8,4.6,1.7,6.6.2-.2.5-.3.9-.5-1-1.9-1.5-4.1-1.6-6.4.2,0,.3,0,.5,0,.1,2.2.7,4.3,1.6,6.2.6-.2,1.2-.5,1.9-.6.6-.2,1.2-.3,1.9-.5,0,.2.1.3.2.5-.7.1-1.3.3-1.9.5,0,0,0,0-.1,0t0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0-.1,0-.2,0h0s0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0c0,0-.1,0-.2,0h0c-.2,0-.4.1-.5.2h0c-.2,0-.3.1-.4.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c-.1,0-.2,0-.3.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0-.2,0-.2.1h0c-.2.1-.3.2-.4.3,0,0,0,0,0,0,0,0,0,0,0,0h0s0,.1,0,.1c0,0,0,0,0,0ZM336,95h0c-5.6-.4-10.4-3.3-13.4-7.7,0,0,0,0,0-.1h0c.1,0,.3-.1.4-.2,2.9,4.2,7.6,7.1,13,7.5v.4ZM336.7,95h0v.3s0,0,0,0h-.4s0,0,0,0v-4.8c.2,0,.3,0,.5,0v4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.5,66.9c2.9-3.8,7.4-6.4,12.4-6.7v1c-3.5.3-6.5,1.5-8.9,3.5h-.9v.8c-.3.3-.6.6-.8.8-.7.2-1.3.4-1.8.6ZM352.5,69.5c-.5,0-.9-.1-1.2-.1,1,1.8,1.7,3.8,2,5.9.4.2.8.3,1.1.5-.2-2.3-.8-4.4-1.8-6.3ZM338.2,61.2c3.5.2,6.6,1.5,9.2,3.6h.9v.8c.3.3.6.6.8.8.7.2,1.3.4,1.8.6-3-3.8-7.5-6.4-12.7-6.7v1ZM324.1,86.8c-.3,0-.7,0-1.1.2,2.9,4.2,7.6,7.1,13,7.5l-.2-1c-4.8-.4-9.1-2.9-11.8-6.7ZM338.2,93.5v1c5.1-.3,9.6-2.8,12.5-6.5-.2-.2-.5-.3-.9-.5-2.8,3.4-6.9,5.7-11.6,6ZM322.6,84.5c-1-1.9-1.5-4.1-1.6-6.4-.3,0-.6,0-1,.2.1,2.4.8,4.6,1.7,6.6.2-.2.5-.3.9-.5ZM352,83.8c.3.3.5.6.7.8.9-1.9,1.5-4.1,1.6-6.4-.4-.1-.7-.2-1-.2,0,2-.6,4-1.3,5.7ZM321.1,75.3c.2-1.5.6-2.9,1.1-4.2-.3-.3-.6-.4-.9-.6-.7,1.6-1.2,3.4-1.3,5.3.3-.2.6-.3,1.1-.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.2,68c-.8-.5-2.4-1-4-1.4v1c2,.4,3.7.9,4.5,1.3l-.5-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.3,67.7c.3,0,.5-.1.8-.2v-.9c-.9.2-1.7.4-2.3.6.4.1.9.3,1.5.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M326.2,74.5c-.2,0-.3,0-.5,0-2.5.5-5.3,1.4-6.1,2.2,0,0,0,0,0,0v.9c.7-.7,3.1-1.5,6.1-2.1.2,0,.4,0,.6-.1v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M354.8,76.7c-.8-.8-3.6-1.7-6.1-2.2-.2,0-.3,0-.5,0v1c.2,0,.4,0,.6.1,3,.6,5.3,1.4,6.1,2.1v-.9s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M327,83.6c-.7.1-1.3.3-1.9.5-1.5.4-3.1,1.1-3.4,1.6,0,0,0,0,0,0l.5.9c.3-.4,1.4-1,3.2-1.5.7-.2,1.4-.4,2.1-.5-.2-.3-.3-.6-.5-1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 336.7,
    y: 59.6,
    width: 1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M337.2,90.5c-.2,0-.3,0-.5,0v4.6h1v-4.7c-.2,0-.4,0-.5,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M352.7,85.4c-.7-1.1-2.5-2.6-4.6-4.2-.1.9-.4,1.8-.8,2.7,2.3,1.7,4,3.2,4.2,3.9l1.3-2c0-.1,0-.2-.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M326.1,68.5c-1.5-.6-2.7-.9-3.4-1h0c-.2,0-.3,0-.4,0l-1.1,2.1s0,0,.1,0c.8,0,2.6.6,4.8,1.6v-2.8Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M348.3,69.1v2c1.2-.2,2.2-.5,3.1-.7-.2-.3-.3-.7-.5-1,.2,0,1.2,0,2.3.2h0s0,0,0,.2c0,0,0,0,0,0s0,0,0,0c0,0,.1-.1,0-.2,0,0,0,0-.2,0h0c-.6-.3-1.5-.6-2.8-.9,0,0,0,0,0,0-.6.2-1.3.4-2,.5ZM355,77.1c0,0,0-.2,0-.3v.3s0,0,.1,0h0ZM352.5,68.3s0,0-.1-.2c0,0-.1,0-.2-.1l.2.4s0,0,0,0ZM352.5,86.2h0s0,0,.1,0c0,0,.2-.2.2-.5l-.3.5ZM355,78.4h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0-.1-.1-.3-.3-.8-.5-1.4-.8-.1,0-.2,0-.4-.1h0v.2c-1.6.5-3.5.9-4.7,1.1v1c0,.3,0,.6,0,.9,1.8-.3,3.4-.6,4.6-1,0-.4,0-.9.1-1.3.3,0,1.1,0,1.9.4,0,0,0,.2,0,.2,0,0,.1,0,.2-.1,0,0,0-.1,0-.2,0,0,0,0,0,0ZM351.2,88.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0-.1c-.1-.3-.6-.8-1.2-1.4,0,0,0,0,0,0,0,0,0,0,0,0h0c-.7-.6-1.6-1.4-2.8-2.3-.5,1.1-1.3,2.1-2.1,2.9-1,1-2.2,1.8-3.5,2.4,1.7-.2,3.3-.4,4.6-.6.5,0,1.3-.2,2.1-.5.4-.4.7-.8,1.1-1.2,1,.2,1.6.8,1.7.9,0,.1-.2.2-.3.3h.1s0,0,.1,0c0,0,.3,0,.2-.4t0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M322,68.2c0,0,0-.1,0-.2,0-.2.1-.3.3-.3l-.3.6ZM319.5,77.1v-.3c0,0-.2.2,0,.3,0,0,0,0,0,0ZM336.2,59.7c0,0-.1,0-.2,0l-.3,1.9c.2,0,.3,0,.5,0v-1.9ZM320.8,70.8c0-.2.1-.3.2-.5.2,0,1,.3,1.6,1.1-.1.3-.3.6-.4,1,.6.5,1.4,1.1,2.4,1.9.3,0,.6-.1.9-.2.2,0,.4,0,.6-.1v-2.1c-1.2-.5-2.2-.9-3.1-1.2h0s0,0,0,0c0,0,0,0,0,0h0c-.8-.3-1.4-.4-1.8-.4s-.1,0-.2,0c0,0,0,0,0,0h0s0,0,0,0h0c-.1,0-.2.1-.3.4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.2,0,.2ZM326.2,79.5v-1c-1.2-.2-3.1-.6-4.7-1.1h0v-.2c-.2,0-.4.1-.5.2-.1,0-.3.1-.4.2,0,0,0,0,0,0,0,0,0,0,0,0-.4.2-.6.4-.8.6,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0t0,0h0c0,0,.1,0,.2.1,0,0,0-.2,0-.2.8-.4,1.6-.4,1.9-.4,0,.4,0,.9.1,1.3,1.2.3,2.8.7,4.6,1,0-.3,0-.6,0-.9ZM336,95c0,0,.1,0,.2,0v-1.9c-.2,0-.3,0-.5,0l.3,1.9ZM329.4,87.2s0,0-.1-.1c-1.7-.3-3.4-.6-5.1-1,0,0,0,0,0,0-.8.3-1.4.7-1.7,1,0,0,0,.1,0,.2h0c0,0,.2,0,.3.1,0,0-.1-.2-.2-.3,1-.5,1.9-.3,2.1-.3.4.6.9,1.1,1.4,1.6,1.9.5,4.2.9,6.7,1.1-1.3-.6-2.4-1.4-3.4-2.3ZM321.6,85.8s0,.1,0,.1c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0v-.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M337.1,90.7c-6.7,0-11.2-5.7-11.2-10.9v-15.1h22.3v15.1c0,5.3-4.5,10.9-11.2,10.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M326.7,65.4v14.3c0,4.9,4.2,10.2,10.4,10.2s10.4-5.3,10.4-10.2v-14.3h-20.8ZM343.3,79.7c0,2.6-2.3,6-6.2,6s-6.2-3.4-6.2-6v-10.1h12.4v10.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M330.3,68.7h0v-.9s.1-.1.1-.2-.1-.2-.2-.2h0v-.4s0,0,0,0h0s0,0,0,0v-.3h-.1v.2h-.2v-.2h-.2v.2h-.2v-.2h-.1v.3s0,0,0,0h.1v.4h-.3v-.9c0,0,0,0,0,0,0,0,0,0,0,0v-.3h-.1c0,.1-.2.1-.2.1h0c0-.1-.1-.1-.1-.1h0c0,.1-.2.1-.2.1h0c0-.1-.1-.1-.1-.1v.3s0,0,0,0h0v.9h-.3v-.4s0,0,0,0h0s0,0,0,0v-.3h-.1v.2h-.2v-.2h-.1v.2h-.2v-.2h-.1v.3s0,0,0,0h0v.4h0c-.1,0-.2,0-.2.2s0,.2.2.2v1h-.1c-.1,0-.2.1-.2.2s.1.2.2.2h2.7c.1,0,.2-.1.2-.2s-.1-.2-.2-.2ZM328.3,68.7c0-.8.6-1,.6-1h0s.6.2.6,1h-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M338.6,68.7h0v-.9s.1-.1.1-.2-.1-.2-.2-.2h0v-.4s0,0,0,0h0s0,0,0,0v-.3h-.1v.2h-.2v-.2h-.1v.2h-.2v-.2h-.1v.3s0,0,0,0h.1v.4h-.3v-.9s0,0,0,0c0,0,0,0,0,0v-.3h-.1c0,.1-.2.1-.2.1h0c0-.1-.1-.1-.1-.1h0c0,.1-.2.1-.2.1h0c0-.1-.1-.1-.1-.1v.3s0,0,0,0h0v.9h-.3v-.4s0,0,0,0h0s0,0,0,0v-.3h-.1v.2h-.2v-.2h-.1v.2h-.2v-.2h-.1v.3s0,0,0,0h.1v.4h0c-.1,0-.2,0-.2.2s0,.2.2.2v1h-.1c-.1,0-.2.1-.2.2s0,.2.2.2h2.7c.1,0,.2-.1.2-.2s-.1-.2-.2-.2ZM336.5,68.7c0-.8.6-1,.6-1h0s.6.2.6,1h-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M346.8,68.7h0v-.9s.1-.1.1-.2-.1-.2-.2-.2h0v-.4s0,0,0,0h0s0,0,0,0v-.3h-.1v.2h-.2v-.2h-.1v.2h-.2v-.2h-.1v.3s0,0,0,0h0v.4h-.3v-.9c0,0,0,0,0,0,0,0,0,0,0,0v-.3h-.1c0,.1-.2.1-.2.1h0c0-.1-.1-.1-.1-.1h0c0,.1-.2.1-.2.1h0c0-.1-.1-.1-.1-.1v.3s0,0,0,0h0v.9h-.3v-.4s0,0,0,0h0s0,0,0,0v-.3h-.1v.2h-.2v-.2h-.1v.2h-.2v-.2h-.1v.3s0,0,0,0h.1v.4h0c-.1,0-.2,0-.2.2s0,.2.2.2v1h-.1c-.1,0-.2.1-.2.2s.1.2.2.2h2.7c.1,0,.2-.1.2-.2s0-.2-.2-.2ZM344.8,68.7c0-.8.6-1,.6-1h0s.6.2.6,1h-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M330.3,77.2h0v-1s.1-.1.1-.2-.1-.2-.2-.2h0v-.4s0,0,0,0h0s0,0,0,0v-.3h-.1v.2h-.2v-.2h-.2v.2h-.2v-.2h-.1v.3s0,0,0,0h.1v.4h-.3v-.9c0,0,0,0,0,0,0,0,0,0,0,0v-.3h-.1c0,.1-.2.1-.2.1h0c0-.1-.1-.1-.1-.1h0c0,.1-.2.1-.2.1h0c0-.1-.1-.1-.1-.1v.3s0,0,0,0h0v.9h-.3v-.4s0,0,0,0h0s0,0,0,0v-.3h-.1v.2h-.2v-.2h-.1v.2h-.2v-.2h-.1v.3s0,0,0,0h0v.4h0c-.1,0-.2.1-.2.2s0,.2.2.2v1h-.1c-.1,0-.2,0-.2.2s.1.2.2.2h2.7c.1,0,.2,0,.2-.2s-.1-.2-.2-.2ZM328.3,77.2c0-.8.6-1,.6-1h0s.6.2.6,1h-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M346.8,77.2h0v-1s.1-.1.1-.2-.1-.2-.2-.2h0v-.4s0,0,0,0h0s0,0,0,0v-.3h-.1v.2h-.2v-.2h-.1v.2h-.2v-.2h-.1v.3s0,0,0,0h0v.4h-.3v-.9c0,0,0,0,0,0,0,0,0,0,0,0v-.3h-.1c0,.1-.2.1-.2.1h0c0-.1-.1-.1-.1-.1h0c0,.1-.2.1-.2.1h0c0-.1-.1-.1-.1-.1v.3s0,0,0,0h0v.9h-.3v-.4s0,0,0,0h0s0,0,0,0v-.3h-.1v.2h-.2v-.2h-.1v.2h-.2v-.2h-.1v.3s0,0,0,0h.1v.4h0c-.1,0-.2.1-.2.2s0,.2.2.2v1h-.1c-.1,0-.2,0-.2.2s.1.2.2.2h2.7c.1,0,.2,0,.2-.2s0-.2-.2-.2ZM344.8,77.2c0-.8.6-1,.6-1h0s.6.2.6,1h-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M332.7,84.7h0s-.7-.6-.7-.6c0,0,0-.2,0-.3,0,0-.3,0-.3,0h0s-.3-.3-.3-.3h0s0,0,0,0c0,0,0,0,0,0l-.2-.2h0c0,0,.1.2.1.2h-.1c0,.1-.1,0-.1,0h-.1c0,0,.1.2.1.2h-.1c0,.1,0,0,0,0h-.1c0,0,.2.3.2.3,0,0,0,0,0,0h0s0,0,0,0l.3.3-.2.2-.7-.6h0c0,0,0,0,0-.1l-.2-.2h-.1c0,0,.1.2.1.2h-.1c0,.1-.1,0-.1,0h-.1c0,.1.1.2.1.2v.2c-.1,0-.2-.1-.2-.1h-.1c0,0,.2.3.2.3,0,0,0,0,0,0h0c0,0,.6.6.6.6l-.2.2-.3-.3h0s0,0,0,0c0,0,0,0,0,0l-.2-.2h0c0,0,.1.2.1.2v.2c-.1,0-.2-.1-.2-.1h-.1c0,.1.1.2.1.2h-.1c0,.1-.1,0-.1,0h0c0,0,.2.3.2.3,0,0,0,0,0,0h0c0,0,0,0,0,0l.3.3h0c0,.1,0,.3,0,.4,0,0,.2,0,.3,0l.6.7h0c0,.1,0,.3,0,.4,0,0,.2,0,.3,0l1.9-1.9c0,0,0-.2,0-.3,0-.1-.3-.1-.3,0ZM331.3,86.1c-.5-.6-.2-1.1-.2-1.1h0s.6-.3,1.1.2l-.9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M341.4,84.7c0,0,0,.2,0,.3l1.9,1.9c0,0,.2,0,.3,0,0,0,0-.2,0-.3h0s.6-.8.6-.8c0,0,.2,0,.3,0,0,0,0-.2,0-.3h0s.3-.3.3-.3h0s0,0,0,0c0,0,0,0,0,0l.2-.2h0c0,0-.1,0-.1,0h-.1c0-.1,0-.2,0-.2h0c0-.1-.1,0-.1,0v-.2c-.1,0,0,0,0,0h0c0,0-.2.1-.2.1,0,0,0,0,0,0h0s0,0,0,0l-.3.3-.2-.2.6-.7h0c0,0,0,0,0,0l.2-.2h0c0,0-.1,0-.1,0v-.2c-.1,0,0,0,0,0h-.1c0-.1,0,0,0,0h-.2c0-.1.1-.2.1-.2h0c0,0-.2.1-.2.1,0,0,0,0,0,0h0s-.7.6-.7.6l-.2-.2.3-.3h0s0,0,0,0c0,0,0,0,0,0l.2-.2h-.1c0,0-.1,0-.1,0h-.1c0-.1.1-.3.1-.3h-.1c0,0-.1,0-.1,0h-.1c0-.1.1-.3.1-.3h-.1c0,0-.2.1-.2.1,0,0,0,0,0,0h0c0,0,0,0,0,0l-.3.3h0c0-.1-.2-.1-.3,0,0,0,0,.2,0,.3l-.7.6h0c0-.1-.2-.1-.3,0ZM342.3,85.2c.6-.5,1.1-.2,1.1-.2h0s.3.6-.2,1.1l-.9-.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M337.9,82.6c-.1,0-.3.1-.3.3s.1.3.3.3.3-.1.3-.3-.1-.3-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.4,82.6c-.1,0-.3.1-.3.3s.1.3.3.3.3-.1.3-.3-.1-.3-.3-.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M337.1,74.6c.6,0,1.4-.5,1.4-1.5v-2h-2.8v2c0,1,.8,1.5,1.4,1.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.8,71.9c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M337.5,72.6c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M338.2,73.3c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M337.9,72.2c.2,0,.3-.1.3-.3s-.1-.3-.3-.3-.3.1-.3.3.1.3.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.4,73.6c.2,0,.3-.1.3-.3s-.1-.3-.3-.3-.3.1-.3.3.1.3.3.3Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M337.1,79.3c.6,0,1.4-.5,1.4-1.5v-2h-2.8v2c0,1,.8,1.5,1.4,1.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.8,76.7c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M337.5,77.4c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M338.2,78.1c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M337.9,77c.2,0,.3-.1.3-.3s-.1-.3-.3-.3-.3.1-.3.3.1.3.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.4,78.4c.2,0,.3-.1.3-.3s-.1-.3-.3-.3-.3.1-.3.3.1.3.3.3Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M333.4,79.3c.6,0,1.4-.5,1.4-1.5v-2h-2.8v2c0,1,.8,1.5,1.4,1.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M333,76.7c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M333.7,77.4c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M334.4,78.1c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M334.1,77c.2,0,.3-.1.3-.3s-.1-.3-.3-.3-.3.1-.3.3.1.3.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M332.6,78.4c.2,0,.3-.1.3-.3s-.1-.3-.3-.3-.3.1-.3.3.1.3.3.3Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M340.9,79.3c.6,0,1.4-.5,1.4-1.5v-2h-2.8v2c0,1,.8,1.5,1.4,1.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M340.5,76.7c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M341.3,77.4c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342,78.1c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M341.6,77c.2,0,.3-.1.3-.3s-.1-.3-.3-.3-.3.1-.3.3.1.3.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M340.2,78.4c.2,0,.3-.1.3-.3s-.1-.3-.3-.3-.3.1-.3.3.1.3.3.3Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M337.1,84.1c.6,0,1.4-.5,1.4-1.5v-2h-2.8v2c0,1,.8,1.5,1.4,1.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.8,81.4c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M337.5,82.1c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M338.2,82.8c0-.2-.1-.3-.3-.3s-.3.1-.3.3.1.3.3.3.3-.1.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M337.9,81.7c.2,0,.3-.1.3-.3s-.1-.3-.3-.3-.3.1-.3.3.1.3.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.4,83.1c.2,0,.3-.1.3-.3s-.1-.3-.3-.3-.3.1-.3.3.1.3.3.3Z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M408.9,78.6l-6.7-10.8h-.6v7.9c.9,0,1.8.2,2.6.4v2.5h-9.8v-2.4c.5-.1,1-.2,1.6-.3.5,0,1.1-.1,1.7-.2v-19.1c-.6,0-1.1-.1-1.7-.2-.5,0-1.1-.2-1.6-.3v-2.4h2.9c.2,0,.6,0,1.1,0,.5,0,1,0,1.6,0,.6,0,1.3,0,2,0,.7,0,1.5,0,2.2,0,1.3,0,2.5.1,3.5.4,1.1.2,2,.6,2.8,1.2.8.5,1.4,1.2,1.8,2.1.4.9.6,1.9.6,3.1s-.2,1.8-.5,2.6c-.3.8-.8,1.5-1.4,2-.6.6-1.3,1.1-2.1,1.4-.8.4-1.7.6-2.6.8.3.3.5.7.8,1,.2.4.5.7.7,1.1l4.3,6.5c.4,0,.8.1,1.3.2.4,0,.9.2,1.4.3v2.5h-5.9ZM407.4,57.7c-.8-.6-2.1-.9-3.8-.9s-.8,0-1.1,0c-.4,0-.7,0-1,0v7.9c.2,0,.5,0,.8,0,.3,0,.7,0,1.2,0,1.6,0,2.9-.4,3.8-1.1.9-.8,1.4-1.8,1.4-3s-.4-2.4-1.3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M416.5,78.6v-2.4c.5-.1,1-.2,1.6-.3.5,0,1.1-.1,1.7-.2v-19.2c-.6,0-1.1-.1-1.7-.2-.5,0-1.1-.2-1.6-.3v-2.4h16.5v6h-2.9c0-.5-.2-1-.3-1.5s-.1-.9-.2-1.3h-6v7.5h4.8c0-.4.1-.8.2-1.2,0-.4.2-.7.3-1.1h2.5v7.6h-2.5c-.1-.3-.2-.7-.3-1.1s-.1-.8-.2-1.2h-4.8v8.1h6c0-.4.1-.9.2-1.4s.2-1,.3-1.6h2.9v6.2h-16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M454.3,64.3c-.5,1-1.1,1.9-2,2.7-.9.8-1.9,1.3-3.1,1.8-1.2.4-2.5.6-4,.6h-.9c-.3,0-.6,0-1,0v6.3c.6,0,1.1.1,1.7.2.5,0,1.1.2,1.6.3v2.4h-10.4v-2.4c.5-.1,1-.2,1.6-.3.5,0,1.1-.1,1.7-.2v-19.1c-.6,0-1.1-.1-1.7-.2-.5,0-1.1-.2-1.6-.3v-2.4h2.8c.3,0,.7,0,1.2,0,.5,0,1.1,0,1.7,0,.6,0,1.3,0,1.9,0,.7,0,1.3,0,2,0,3,0,5.3.7,6.8,2,1.6,1.3,2.4,3.2,2.4,5.5s-.2,2.3-.7,3.4ZM449.5,57.9c-.9-.8-2.2-1.2-4-1.2h-1.1c-.3,0-.7,0-1,0v9.1c.3,0,.6,0,.9.1.3,0,.6,0,.9,0,1.7,0,3.1-.5,4.1-1.3,1-.9,1.5-2,1.5-3.5s-.4-2.5-1.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M478.7,56.5v12.5c0,3.4-.9,5.8-2.6,7.5-1.7,1.6-4.2,2.4-7.5,2.4s-3.6-.2-4.8-.7c-1.2-.5-2.2-1.2-2.9-2-.7-.8-1.2-1.8-1.4-2.8-.3-1.1-.4-2.2-.4-3.3v-13.5c-.4,0-.8-.1-1.3-.2-.4,0-.8-.2-1.2-.3v-2.5h9.3v2.5c-.4.1-.9.2-1.4.3-.5,0-1,.1-1.4.2v13.3c0,.8,0,1.6.2,2.3.2.7.4,1.3.9,1.9.4.5,1,.9,1.8,1.2.8.3,1.7.4,2.9.4s1.9-.1,2.6-.3c.7-.2,1.4-.6,1.8-1.1.5-.5.8-1.2,1.1-2,.2-.8.4-1.8.4-3v-12.7c-.5,0-1-.1-1.4-.2-.5,0-1-.2-1.4-.3v-2.5h9.3v2.5c-.8.2-1.6.3-2.4.4ZM468.2,51.8l-1.5-2.3,5.8-4.1,1.8,2.7-6.1,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M503,73.6c-.3.9-.8,1.7-1.6,2.5s-1.7,1.4-3,1.9c-1.3.5-2.9.7-4.8.7s-1.7,0-2.9,0c-1.2,0-2.5,0-3.8,0h-3.2v-2.4c.5-.1,1-.2,1.6-.3.5,0,1.1-.1,1.7-.2v-19.1c-.6,0-1.1-.1-1.7-.2-.5,0-1.1-.2-1.6-.3v-2.4h3.1c.9,0,2.1,0,3.5,0,1.4,0,2.9,0,4.4,0,2.7,0,4.8.5,6.2,1.6,1.4,1.1,2.1,2.6,2.1,4.5s-.4,2.4-1.2,3.5c-.8,1-1.8,1.8-3.1,2.2h0c.8.2,1.5.5,2.1.9.6.4,1.1.8,1.5,1.3.4.5.7,1.1.9,1.7.2.6.3,1.2.3,1.9s-.2,1.7-.5,2.6ZM498.5,58.8c-.1-.4-.4-.8-.8-1.1-.4-.3-.9-.5-1.5-.7-.6-.2-1.4-.3-2.2-.3s-1.1,0-1.6,0c-.5,0-1,0-1.5,0v7.4c.3,0,.7,0,1,0h1.1c1.9,0,3.3-.4,4.3-1.1,1-.7,1.4-1.7,1.4-3s0-1-.2-1.4ZM498.7,69.3c-.3-.5-.7-.9-1.3-1.2-.5-.3-1.2-.5-1.9-.7-.7-.1-1.6-.2-2.4-.2h-1.1c-.2,0-.4,0-.6,0-.2,0-.4,0-.5,0v8c.7.1,1.7.2,2.9.2,1.9,0,3.2-.4,4.1-1.2.9-.8,1.3-1.8,1.3-3.1s-.2-1.3-.5-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M506.3,78.6v-2.4c.5-.1,1-.2,1.6-.3.5,0,1.1-.1,1.7-.2v-19.1c-.6,0-1.1-.1-1.7-.2-.5,0-1.1-.2-1.6-.3v-2.4h10.4v2.4c-.5.1-1,.2-1.6.3-.5,0-1.1.1-1.7.2v18.7h5.7c.1-1,.3-2,.5-3.2h2.9v6.6h-16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M524.1,78.6v-2.4c.5-.1,1-.2,1.6-.3.5,0,1.1-.1,1.7-.2v-19.1c-.6,0-1.1-.1-1.7-.2-.5,0-1.1-.2-1.6-.3v-2.4h10.4v2.4c-.5.1-1,.2-1.6.3-.5,0-1.1.1-1.7.2v19.1c.6,0,1.1.1,1.7.2.5,0,1.1.2,1.6.3v2.4h-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M552.4,60.6c-.1-.6-.2-1.2-.3-1.7,0-.5-.1-1-.2-1.5-.6-.1-1.1-.2-1.6-.3-.5,0-1,0-1.6,0-1.2,0-2.3.2-3.2.7-.9.5-1.7,1.1-2.3,1.9-.6.8-1.1,1.8-1.4,2.9-.3,1.1-.4,2.4-.4,3.7s.2,2.7.5,3.8c.3,1.1.8,2.1,1.5,2.9.7.8,1.5,1.4,2.6,1.8,1,.4,2.3.6,3.7.6s1.9-.1,2.9-.3c1-.2,1.9-.5,2.7-.8l.3,3.7c-1,.3-2.1.6-3.3.8-1.1.2-2.3.3-3.5.3-3.9,0-6.9-1.1-8.8-3.2-2-2.1-2.9-5.1-2.9-8.9s.3-3.8.8-5.4c.5-1.7,1.3-3.1,2.3-4.3,1-1.2,2.3-2.1,3.9-2.8,1.6-.7,3.4-1,5.6-1s1.9,0,2.9.2c1,.1,2,.3,2.9.5v6.6h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M573.3,78.6v-2.4c.4,0,.9-.2,1.4-.3.5,0,1-.1,1.4-.2l-1.3-3.5h-9.9l-1.3,3.5c.5,0,.9.1,1.4.2.5,0,.9.2,1.4.3v2.4h-9v-2.4c.3,0,.7-.2,1.1-.2.4,0,.7-.1,1.1-.2l8-22.1h4.8l8.1,22.1c.3,0,.7.1,1.1.2s.7.1,1.1.2v2.4h-9.4ZM571,61.5c-.2-.6-.5-1.3-.6-1.9-.2-.6-.3-1.3-.5-2h0c-.1.6-.3,1.3-.5,2-.2.7-.4,1.3-.7,2l-2.7,7.4h7.8l-2.8-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M412.5,99.9c-.5,1-1.1,1.9-2,2.7-.9.8-1.9,1.3-3.1,1.8-1.2.4-2.5.6-4,.6h-.9c-.3,0-.6,0-1,0v6.3c.6,0,1.1.1,1.7.2.5,0,1.1.2,1.6.3v2.4h-10.4v-2.4c.5-.1,1-.2,1.6-.3.5,0,1.1-.1,1.7-.2v-19.1c-.6,0-1.1-.1-1.7-.2-.5,0-1.1-.2-1.6-.3v-2.4h2.8c.3,0,.7,0,1.2,0,.5,0,1.1,0,1.7,0,.6,0,1.3,0,1.9,0,.7,0,1.3,0,2,0,3,0,5.3.7,6.8,2,1.6,1.3,2.4,3.2,2.4,5.5s-.2,2.3-.7,3.4ZM407.7,93.5c-.9-.8-2.2-1.2-4-1.2h-1.1c-.3,0-.7,0-1,0v9.1c.3,0,.6,0,.9.1.3,0,.6,0,.9,0,1.7,0,3.1-.5,4.1-1.3,1-.9,1.5-2,1.5-3.5s-.4-2.5-1.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M437.5,106.9c-.6,1.6-1.5,3-2.6,4.1-1.1,1.1-2.4,2-3.8,2.6-1.5.6-3,.9-4.7.9s-3.6-.3-5-.9c-1.4-.6-2.6-1.4-3.5-2.5-.9-1.1-1.6-2.4-2.1-4-.5-1.5-.7-3.3-.7-5.2s.3-3.9.9-5.6c.6-1.6,1.5-3,2.6-4.1,1.1-1.1,2.4-2,3.8-2.6,1.5-.6,3-.9,4.7-.9s3.2.3,4.6.8c1.4.5,2.6,1.3,3.6,2.4,1,1,1.8,2.4,2.3,3.9.5,1.6.8,3.4.8,5.5s-.3,3.9-.9,5.6ZM432.2,94.8c-1.3-1.6-3.1-2.4-5.4-2.4s-1.9.2-2.8.6c-.9.4-1.7,1-2.3,1.7s-1.2,1.7-1.6,2.9c-.4,1.1-.6,2.5-.6,4s.1,2.7.4,3.9c.3,1.2.7,2.2,1.3,3,.6.8,1.4,1.5,2.3,1.9.9.5,2,.7,3.2.7s1.8-.2,2.7-.6c.9-.4,1.7-.9,2.4-1.7s1.3-1.7,1.7-2.9.6-2.5.6-4.1c0-3-.6-5.4-1.9-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M455.4,114.2l-6.7-10.8h-.6v7.9c.9,0,1.8.2,2.6.4v2.5h-9.8v-2.4c.5-.1,1-.2,1.6-.3.5,0,1.1-.1,1.7-.2v-19.1c-.6,0-1.1-.1-1.7-.2-.5,0-1.1-.2-1.6-.3v-2.4h2.9c.2,0,.6,0,1.1,0,.5,0,1,0,1.6,0,.6,0,1.3,0,2,0,.7,0,1.5,0,2.2,0,1.3,0,2.5.1,3.5.4,1.1.2,2,.6,2.8,1.2.8.5,1.4,1.2,1.8,2.1.4.9.6,1.9.6,3.1s-.2,1.8-.5,2.6c-.3.8-.8,1.5-1.4,2-.6.6-1.3,1.1-2.1,1.4-.8.4-1.7.6-2.6.8.3.3.5.7.8,1,.2.4.5.7.7,1.1l4.3,6.5c.4,0,.8.1,1.3.2.4,0,.9.2,1.4.3v2.5h-5.9ZM453.9,93.3c-.8-.6-2.1-.9-3.8-.9s-.8,0-1.1,0c-.4,0-.7,0-1,0v7.9c.2,0,.5,0,.8,0,.3,0,.7,0,1.2,0,1.6,0,2.9-.4,3.8-1.1.9-.8,1.4-1.8,1.4-3s-.4-2.4-1.3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M479.6,95.8c-.1-.6-.2-1.2-.3-1.8,0-.5-.2-1-.2-1.5h-4.5v18.7c.6,0,1.1.1,1.7.2.5,0,1.1.2,1.6.3v2.4h-10.4v-2.4c.5-.1,1-.2,1.6-.3.5,0,1.1-.1,1.7-.2v-18.7h-4.6c0,.5-.1,1-.2,1.5,0,.5-.2,1.1-.3,1.8h-2.9v-6.6h19.8v6.6h-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M506.2,92.1v12.5c0,3.4-.9,5.8-2.6,7.5-1.7,1.6-4.2,2.4-7.5,2.4s-3.6-.2-4.8-.7c-1.2-.5-2.2-1.2-2.9-2-.7-.8-1.2-1.8-1.4-2.8-.3-1.1-.4-2.2-.4-3.3v-13.5c-.4,0-.8-.1-1.3-.2-.4,0-.8-.2-1.2-.3v-2.5h9.3v2.5c-.4.1-.9.2-1.4.3s-1,.1-1.4.2v13.3c0,.8,0,1.6.2,2.3.2.7.4,1.3.9,1.9.4.5,1,.9,1.8,1.2.8.3,1.7.4,2.9.4s1.9-.1,2.6-.3c.7-.2,1.4-.6,1.8-1.1.5-.5.8-1.2,1.1-2,.2-.8.4-1.8.4-3v-12.7c-.5,0-1-.1-1.4-.2s-1-.2-1.4-.3v-2.5h9.3v2.5c-.8.2-1.6.3-2.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M533.1,104c-.4,0-.8.1-1.2.2v8.8c-1.3.5-2.6.9-4.1,1.1-1.5.3-2.9.4-4.3.4s-3.7-.3-5.2-.9c-1.5-.6-2.9-1.4-3.9-2.4-1.1-1-1.9-2.3-2.5-3.9-.6-1.5-.9-3.3-.9-5.2s.3-3.7.9-5.4c.6-1.6,1.5-3.1,2.7-4.2,1.2-1.2,2.6-2.1,4.3-2.8,1.7-.7,3.6-1,5.7-1s2.3,0,3.4.2c1.1.2,2.3.4,3.4.7v6.3h-3c-.1-.6-.2-1.1-.3-1.6,0-.5-.1-1-.2-1.5-.6-.1-1.2-.3-1.9-.4-.6,0-1.2-.1-1.8-.1-1.3,0-2.4.2-3.5.6-1.1.4-2,1-2.9,1.8-.8.8-1.5,1.8-1.9,3-.5,1.2-.7,2.5-.7,4.1,0,2.9.8,5.2,2.3,6.7,1.5,1.6,3.7,2.4,6.4,2.4s1.4,0,2-.1c.6,0,1.2-.2,1.8-.4v-6.1c-.6,0-1.1-.1-1.7-.2-.5,0-1-.2-1.5-.3v-2.4h9.4v2.5c-.3,0-.7.2-1.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M558.2,92.1v12.5c0,3.4-.9,5.8-2.6,7.5-1.7,1.6-4.2,2.4-7.5,2.4s-3.6-.2-4.8-.7c-1.2-.5-2.2-1.2-2.9-2-.7-.8-1.2-1.8-1.4-2.8-.3-1.1-.4-2.2-.4-3.3v-13.5c-.4,0-.8-.1-1.3-.2-.4,0-.8-.2-1.2-.3v-2.5h9.3v2.5c-.4.1-.9.2-1.4.3-.5,0-1,.1-1.4.2v13.3c0,.8,0,1.6.2,2.3.2.7.5,1.3.9,1.9.4.5,1,.9,1.8,1.2.8.3,1.7.4,2.9.4s1.9-.1,2.6-.3c.7-.2,1.4-.6,1.8-1.1.5-.5.8-1.2,1.1-2,.2-.8.4-1.8.4-3v-12.7c-.5,0-1-.1-1.4-.2-.5,0-1-.2-1.4-.3v-2.5h9.3v2.5c-.8.2-1.6.3-2.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M563.2,114.2v-2.4c.5-.1,1-.2,1.6-.3.5,0,1.1-.1,1.7-.2v-19.2c-.6,0-1.1-.1-1.7-.2-.5,0-1.1-.2-1.6-.3v-2.4h16.5v6h-2.9c0-.5-.2-1-.3-1.5,0-.5-.1-.9-.2-1.3h-6v7.5h4.8c0-.4.1-.8.2-1.2,0-.4.2-.7.3-1.1h2.5v7.6h-2.5c-.1-.3-.2-.7-.3-1.1,0-.4-.1-.8-.2-1.2h-4.8v8.1h6c0-.4.1-.9.2-1.4,0-.5.2-1,.3-1.6h2.9v6.2h-16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M598.4,109.8c-.4,1-1.1,1.8-1.9,2.5-.8.7-1.8,1.3-3,1.6-1.2.4-2.5.6-3.9.6s-3.8-.2-5.5-.6v-6.3h3c0,.6.2,1.1.3,1.6,0,.5.1,1,.2,1.5.3,0,.7.1,1.1.2.4,0,.8,0,1.1,0,.7,0,1.4,0,2-.2s1.2-.4,1.6-.7c.5-.3.8-.7,1.1-1.2s.4-1.1.4-1.7-.3-1.6-.8-2.1c-.6-.5-1.2-1-2.1-1.3-.8-.4-1.7-.7-2.7-1.1-1-.3-1.9-.8-2.7-1.3-.8-.5-1.5-1.2-2.1-2.1-.6-.8-.8-1.9-.8-3.3s.2-2,.6-2.9c.4-.9,1-1.7,1.8-2.3.8-.6,1.7-1.1,2.9-1.5,1.1-.4,2.4-.5,3.8-.5s1.7,0,2.5.1c.8,0,1.6.2,2.5.4v6h-3c-.1-.5-.2-1.1-.3-1.6,0-.5-.1-1-.2-1.4-.2,0-.5,0-.8-.1-.3,0-.6,0-.9,0-1.6,0-2.7.3-3.5,1-.8.7-1.2,1.5-1.2,2.5s.3,1.5.8,2c.6.5,1.2.9,2.1,1.3.8.4,1.7.7,2.7,1.1,1,.4,1.9.8,2.7,1.3.8.5,1.5,1.2,2.1,2,.6.8.8,1.9.8,3.2s-.2,2.2-.7,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M616.1,114.2v-2.4c.4,0,.9-.2,1.4-.3.5,0,1-.1,1.4-.2l-1.3-3.5h-9.9l-1.3,3.5c.5,0,.9.1,1.4.2.5,0,.9.2,1.4.3v2.4h-9v-2.4c.3,0,.7-.2,1.1-.2s.7-.1,1.1-.2l8-22.1h4.8l8.1,22.1c.3,0,.7.1,1.1.2.4,0,.7.1,1.1.2v2.4h-9.4ZM613.8,97.1c-.2-.6-.5-1.3-.6-1.9-.2-.6-.3-1.3-.5-2h0c-.1.6-.3,1.3-.5,2-.2.7-.4,1.3-.7,2l-2.7,7.4h7.8l-2.8-7.6Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFooterColor);
export default __webpack_public_path__ + "static/media/logos_footer_color.675c40dce5be33c177b1cea65e034c5f.svg";
export { ForwardRef as ReactComponent };